import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { CreditCard, Package, Loader2 } from "lucide-react";

interface PaymentConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  prescriptionId?: string;
  patientName?: string;
  onConfirm: () => Promise<void> | void;
  isLoading?: boolean;
}

const PaymentConfirmationDialog: React.FC<PaymentConfirmationDialogProps> = ({
  open,
  onOpenChange,
  prescriptionId,
  patientName,
  onConfirm,
  isLoading = false
}) => {
  const handleConfirm = async () => {
    try {
      await onConfirm();
      onOpenChange(false);
    } catch (error) {
      // Error handling is done in the parent component
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <CreditCard className="h-5 w-5 text-blue-600" />
            Confirm Payment & Order
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            {/* <p>
              Are you sure you want to process payment and place the order for this prescription?
            </p> */}
            {patientName && (
              <p className="text-sm text-slate-600">
                <strong>Patient:</strong> {patientName}
              </p>
            )}
            {prescriptionId && (
              <p className="text-sm text-slate-600">
                <strong>Order ID:</strong> {prescriptionId}
              </p>
            )}
            <div className="bg-blue-50 p-3 rounded-md mt-3">
              <div className="flex items-start gap-2">
                <Package className="h-4 w-4 text-blue-600 mt-0.5" />
                <div className="text-sm text-blue-800">
                  <p className="font-medium">This action will:</p>
                  <ul className="list-disc list-inside mt-1 space-y-1">
                    <li>Mark the prescription as paid</li>
                    <li>Send the order to the pharmacy</li>
                    <li>Initiate the fulfillment process</li>
                  </ul>
                </div>
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={handleConfirm}
            disabled={isLoading}
            className="bg-blue-600 hover:bg-blue-700"
          >
            {isLoading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin mr-2" />
                Processing...
              </>
            ) : (
              'Confirm Payment & Order'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default PaymentConfirmationDialog; 